import { IBasePagedModel, IBaseSortModel } from '../../../interfaces/PagedSortedSearch';

import ApiClient from '../../../services/apiClient';
import { HttpResponseError } from '../../../interfaces/IHttpResponseError';
import { IUserModel } from '../../../interfaces/IUser';
import { useQuery } from 'react-query';
import { SortDirections } from '../../../utilities/Constants';

const _apiClient = new ApiClient();

export enum CaseResolutionSortColumns {
    CaseNumber = 1,
    CaseName = 2,
    TrialDate = 3,
    Jurisdiction = 4,
    Plaintiff = 5,
    NationalPlaintiff = 6,
    Zone = 7,
    Assigned = 8,
    SqScore = 9,
}

export interface CreateCaseResolutionPlanRequest {
    CaseId: string;
}

export const CaseResolutionCurrentStepEnum = {
    Drafter: {
        label: "Drafter",
        value: "Drafter",
        id: 1,
    },
    A1: {
        label: "A1",
        value: "A1",
        id: 2,
    },
    A2: {
        label: "A2",
        value: "A2",
        id: 3,
    },
    CDLead: {
        label: "CD Lead", //Changed as per the DB step names for filter purpose.
        value: "CD Lead",
        id: 7,
    },
    AdminQC: {
        label: "Admin QC",
        value: "Admin QC",
        id: 4,
    },
    LegalQC: {
        label: "Legal QC",
        value: "Legal QC",
        id: 5,
    },
    FinalReview: {
        label: "Final Review",
        value: "Final Review",
        id: 6
    },
}

export const CaseResolutionQScoreEnum = {
    SQ1: {
        label: "SQ1",
        value: "SQ1",
        id: 1,
    },
    SQ2: {
        label: "SQ2",
        value: "SQ2",
        id: 2,
    },
    SQ3: {
        label: "SQ3",
        value: "SQ3",
        id: 3,
    },
    SQ4: {
        label: "SQ4",
        value: "SQ4",
        id: 4,
    },
    SQ5: {
        label: "SQ5",
        value: "SQ5",
        id: 5,
    },
};

export const OrganizationDependencyTypesEnum = {
    Master: {
        id: 1,
        DisplayName: 'Master',
    },
    Associated: {
        id: 2,
        DisplayName: 'Associated',
    },
    None: {
        id: 3,
        DisplayName: 'None',
    },
};

export interface ICaseResolutionCaseManager {
    id: string;
    name: string;
}

export interface ICaseResolutionPlaintiffFirms {
    id: string;
    name: string;
}

export interface ICaseResolutionResponseModel {
    guid: string;
    plaintiffFirm: string;
    nationalPlaintiffFirm: string;
    jurisdiction: string;
    caseName: string;
    caseStep: number;
    sqScore: number;
    Assigned: boolean;
    trialDate: Date;
}

export interface ICaseResolutionSearchModel {
    caseNumber?: string;
    caseName?: string;
    jurisdiction?: string[];
    plaintiffsFirm?: string[];
    nationalPlaintiffsFirm?: string[];
    caseManagerId?: string[];
    pagedModel: IBasePagedModel;
    sortModel: IBaseSortModel<CaseResolutionSortColumns>;
    includedSteps?: boolean;
    states?: string[];
    qScore?: string[];
    currentStep?: string[];
    zoneId?: string[];
    startTrialDate?: string;
    endTrialDate?: string;
}

export const useGetCaseResolutionQuery = (caseId: string) => {
    return useQuery({
        queryKey: ['get-case-groups-query', { caseId }],
        queryFn: async () => {
            const response = await _apiClient.getCaseResolutionCase(caseId);

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const error: HttpResponseError = new Error('Failed to search case resolution cases');
                error.status = response.httpResponse.status;
                throw error;
            }
            return response.payload;
        },
        cacheTime: 0,
        staleTime: 0,
    });
};
